import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const CheckboxContainer = styled.div`
  margin-right: var(--space-200);
`
